/* eslint camelcase: 0 */
import { toHospitalProps } from './hospital'
import { toLogProps } from './log'
import { Doctor, DoctorRequest, ProfileRequest } from '@/infrastructure/network/Monitaro/schema/models'
import { IDoctorProps, EmptyDoctorPropsFactory } from '@/entities/Doctor'

export const toDoctorProps = (props: Doctor | null | undefined): IDoctorProps => {
  if (!props) {
    return EmptyDoctorPropsFactory()
  }

  const {
    id,
    hospitals,
    division,
    occupation,
    role,
    name,
    username,
    login,
    fcm_token,
    uuid,
    fullname,
    kana,
    organization,
    properties,
    flags,
    provider,
    activation,
    is_calendar_visible,
    is_calendar_blocking,
    log,
    areas,
    invited_at,
    activate_at,
    created_at,
    updated_at
  } = props

  return EmptyDoctorPropsFactory({
    id,
    hospitals: hospitals?.map(toHospitalProps),
    division,
    occupation,
    role,
    name,
    username,
    login,
    fcmToken: fcm_token,
    uuid,
    fullname,
    kana,
    organization,
    properties,
    flags,
    provider,
    activation,
    isCalendarVisible: is_calendar_visible,
    isCalendarBlocking: is_calendar_blocking ?? false,
    log: toLogProps(log),
    areas: areas?.map((area) => area.id!),
    invitedAt: invited_at,
    activateAt: activate_at,
    createdAt: created_at,
    updatedAt: updated_at,
    hospitalId: hospitals?.[0]?.id,
    divisionId: division?.id
  })
}

export const toDoctorRequest = (props: IDoctorProps): DoctorRequest => {
  const { username, hospitalId, divisionId, occupation, role } = props
  return {
    username: username!,
    hospital_id: hospitalId!,
    division_id: divisionId!,
    occupation: occupation!,
    role: role!
  }
}

export const toProfileRequest = (props: IDoctorProps, { includeAreas = true }: { includeAreas?: boolean } = {}): ProfileRequest => {
  const { name, flags, properties, areas } = props
  return {
    name: name!,
    flags,
    properties,
    ...(includeAreas ? { areas } : {})
  }
}

export const toCalendarVisibleRequest = (isCalendarVisible: boolean): ProfileRequest => ({
  is_calendar_visible: isCalendarVisible
})

export const toCalendarBlockingRequest = (isCalendarBlocking: boolean): ProfileRequest => ({
  is_calendar_blocking: isCalendarBlocking
})
